import { useQuestionsStore } from "@/stores/questions";
import { event } from "vue-gtag";
import { useMainStore } from "@/stores/main";
import { useSupplementsStore } from "@/stores/supplements";
import { useProductsStore } from "@/stores/products";

export enum AnalitycsEvents {
  BEGIN = "add_to_cart",
  BEGIN_QUEST = "begin_questionnaire",
  BEGIN_BASICS_QUEST = "begin_basics_questionnaire",
  BEGIN_HEALTH_QUEST = "begin_health_concerns_questionnaire",
  BEGIN_LIFESTYLE_QUEST = "begin_lifestyle_questionnaire",
  FINISH_QUEST = "finish_questionnaire",
  BEGIN_CHECKOUT = "begin_checkout",
  LEAD = "lead_submit",
  PRODUCT_SELECT = "product_select",
  ADD_SHIPPING = "add_shipping_info",
  PAYMENT_SELECTED = "payment_selected",
  PURCHASE = "purchase",

  ABANDONED_CHECKOUT_RECOVERY = "abandoned_checkout_recovery",
  REDIRECTED_TO_LP = "redirected_to_lp",
}

const defaultParams = () => {
  const mainStore = useMainStore();
  return {
    country_iso_code: mainStore.ipLocationCountryCode,
    product_type: "GO",
  };
};

export function sendEvent(eventName: AnalitycsEvents) {
  const params: any = { ...defaultParams(), ...productDetails() };
  event(eventName, params);
}

function sendLeadEvent(customerInformation: any, isAfterQuest = false) {
  event(AnalitycsEvents.LEAD, {
    ...defaultParams(),
    type: isAfterQuest ? "go_questionnaire" : "checkout",
    first_name: customerInformation.firstName,
    last_name: customerInformation.lastName,
    phone: customerInformation.phoneNumber,
    email: customerInformation.email,
  });
}

export function sendLeadEventAfterQuest() {
  // don't send event if marketing consent was not selected
  const questionsStore = useQuestionsStore();
  if (!questionsStore.lifestyleStore.marketingConsentSelected) return;

  const info = {
    firstName: questionsStore.lifestyleStore.firstName,
    lastName: questionsStore.lifestyleStore.lastName,
    email: questionsStore.lifestyleStore.email,
  };
  sendLeadEvent(info, true);
}

function productDetails() {
  const productStore = useProductsStore();
  const product = productStore.selectedProduct;
  if (!product) return {};

  return {
    currency: product.currency,
    items: [
      {
        item_id: product.id,
        item_name: product.name,
        price: product.price,
      },
    ],
  };
}

export function sendFormulaGuardEvents() {
  const mainStore = useMainStore();
  if (!mainStore.hubspotContactEmail) return false;

  const supplementStore = useSupplementsStore();

  if (
    supplementStore.supplementsFormula &&
    supplementStore.supplementsFormula.supplements &&
    supplementStore.supplementsFormula.supplements.length
  ) {
    sendEvent(AnalitycsEvents.ABANDONED_CHECKOUT_RECOVERY);
    return true;
  } else {
    sendEvent(AnalitycsEvents.REDIRECTED_TO_LP);
    return false;
  }
}
